Vue.component('the-header', {
    data() {
        return {
            mobileOpen: false
        }
    },
    methods: {
        toggleMobileCatalog() {
            this.mobileOpen = !this.mobileOpen
        },
        hideMobileCatalog() {
            this.mobileOpen = false
        },
        openOrderCall() {
            store.dispatch('setOrderCallModal', true)
        }
    },
    computed: {
        white() {
            return store.state.white
        }
    },
    created() {
        window.addEventListener('hashchange', this.hideMobileCatalog);
    },
})
